module.exports = __webpack_public_path__ + "img/9.90ef5cf9.png";